/**
 * o2o.js
 *
 * @Author: apple
 * @Date: 2018/2/5 22:59
 */
import { isNull, isUndefined, isNumber, isBoolean } from './isType';
// 去重
Array.prototype.unique = function() {
    this.sort();
    const re = [this[0]];
    for (let i = 1; i < this.length; i++) {
        if (this[i] !== re[re.length - 1]) {
            re.push(this[i]);
        }
    }
    return re;
};
const isValidData = (a, b) => {
    if (typeof a !== typeof b) {
        return false;
    }
    if (isNull(a) || isUndefined(a) || isNumber(a) || isBoolean(a)) {
        return false;
    }
    if (typeof a.length !== typeof b.length) {
        return false;
    }
    if (a.length !== b.length) {
        return false;
    }
    return true;
};

export const isEqualArrays = (a1, a2) => {
    let bool;
    if (!isValidData(a1, a2)) {
        return false;
    }
    bool = a1.some((e, i) => e !== a2[i]);
    return !bool;
};

export const o2o = (o1, o2, debug) => {
    if (typeof o1 !== typeof o2) {
        return false;
    }

    if (isNull(o1) || isUndefined(o1) || isNumber(o1) || isBoolean(o1)) {
        return false;
    }

    if (typeof o1.length !== typeof o2.length) {
        return false;
    }

    let bool = true;

    const keyArr1 = [];
    const keyArr2 = [];

    for (const i in o1) {
        keyArr1.push(i);
    }

    for (const i in o2) {
        keyArr2.push(i);
    }

    if (keyArr1.length != keyArr2.length) {
        return false;
    }

    for (let i = 0, k = keyArr2.length; i < k; i++) {
        keyArr1.push(keyArr2[i]);
    }

    const keyArr = keyArr1.unique();
    for (let i = 0, k = keyArr.length; i < k; i++) {
        if (keyArr[i] in o1 && keyArr[i] in o2) {
            if (typeof o1[keyArr[i]] === 'object' && typeof o2[keyArr[i]] === 'object') {
                bool = o2o(o1[keyArr[i]], o2[keyArr[i]]);
            } else if (o1[keyArr[i]] !== o2[keyArr[i]]) {
                return false;
            }
        } else {
            return false;
        }
    }

    return bool;
};

export default o2o;



// WEBPACK FOOTER //
// ./src/util/isEqual.js